import localProvider from '@disco/services/upload/providers/local'
import { webkitDirectorySupported } from '@disco/utils/browser'

import React from 'react'
import { MdOutlineFolder } from '@react-icons/all-files/md/MdOutlineFolder'
import { MdUploadFile } from '@react-icons/all-files/md/MdUploadFile'
import type { UploadProvider } from 'types/upload'
import FileSelect from 'components/common/file-select'
import { Button, Flex } from 'components/ds'
type Props = {
  onFilesSelect: (files: any, provider: UploadProvider) => void
}

const UploadFileOrFolderButtons = ({
  onFilesSelect,
}: Props): React.ReactNode => {
  const handleChange = (files: File[]) => {
    onFilesSelect(files, localProvider)
  }

  return (
    <Flex gap="2">
      <FileSelect multiple onChange={handleChange}>
        <Button size="3" data-testid="button-primary">
          <MdUploadFile />
          Add file
        </Button>
      </FileSelect>
      {webkitDirectorySupported() && (
        <FileSelect directory multiple onChange={handleChange}>
          <Button size="3" variant="surface" data-testid="button-subtle">
            <MdOutlineFolder />
            Add folder
          </Button>
        </FileSelect>
      )}
    </Flex>
  )
}

export default UploadFileOrFolderButtons
